'use strict';

import {request, extend, identity, isUndefined} from './../lang';

export default class Action {
  /**
   * @param {Object} options
   * @param {Object} callbacks
   */
  constructor(options, callbacks) {
    let {onError} = callbacks;
    this.options = options;
    this.isPending = false;
    this.onError = onError;
    this.onComplete = this.onComplete.bind(this);
  }
  /**
   * @param {*} body
   * @returns {Promise.<T>}
   */
  get(body) {
    return this.send(body,{method:'GET'});
  }
  /**
   * @param {*} body
   * @returns {Promise.<T>}
   */
  post(body) {
    return this.send(body,{method:'POST'});
  }
  /**
   * @param {*} body
   * @param {Object} [options]
   * @returns {Promise.<T>}
   */
  send(body, options) {
    let {onComplete,onError} = this;
    let opts = extend({}, this.options);
    opts = isUndefined(body) ? opts : extend(opts, {body});
    opts = isUndefined(options) ? opts : extend(opts, options);
    let fetchFn = this.constructor.fetch();
    let promise = request(opts.url, opts, fetchFn);
    this.isPending = true;
    return promise.then(onComplete, onComplete)
                  .then(identity, onError);
  }
  /**
   * @param {Object} error
   */
  onError(error) {
    console.warn(error);
    return error;
  }
  /**
   * @param {*} response
   */
  onComplete(response) {
    this.isPending = false;
    return response;
  }
  /**
   * DI
   * @returns {Function}
   */
  static fetch() {
    return (window.jQuery && window.jQuery.ajax) || window.fetch;
  }
}


// WEBPACK FOOTER //
// ./src/js/classes/Action.js